import React from 'react';
import IconButton from 'material-ui/IconButton';
import Info from 'material-ui/svg-icons/action/info';
import { Row, Col } from 'react-flexbox-grid';

import HistoryEntry from 'components/HistoryEntry';
import HistoryEntryHeader from 'components/HistoryEntryHeader';
import HistoryEntryColumns from 'components/HistoryEntryColumns';
import HistoryEntryColumn from 'components/HistoryEntryColumn';
import CommonHistoryEntryControls from 'routes/Documents/components/CommonHistoryEntryControls';
import CommonViewButton from 'routes/Documents/components/CommonViewButton';
import { getLatestFinishedCommitData } from 'lib/documentHandling';

import { formatHeaderDate, editTimeLeft } from 'lib/dateDisplay';
import { colors, dimensions } from 'styles/provider';
import { dateFromPartial, isPartialDate } from 'neuro-utils';

const styles = {
  color: colors.clrSecondary,
  button: {
    width: dimensions.infoButtonSize,
    height: dimensions.infoButtonSize,
    boxSizing: 'content-box',
    padding: 0,
  },
  icon: {
    width: dimensions.infoIconSize,
    height: dimensions.infoIconSize,
  },
};

export const sorter = docs =>
  docs.sort(
    (d1, d2) =>
      (isPartialDate(d2?.content?.date) ? dateFromPartial(d2.content.date) : d2.createDate) -
      (isPartialDate(d1?.content?.date) ? dateFromPartial(d1.content.date) : d1.createDate),
  );

const msg = id => ({ id });

const renderEntryHeader = (doc, fm) => `${formatHeaderDate(doc.createDate)}`;

const renderHeader = m => <p children={m} />;

const historyMapper =
  (name, edit, view, setDialog) =>
  (d, { formatMessage }) => (
    <HistoryEntry key={d.documentId}>
      <HistoryEntryHeader title={renderEntryHeader(d, formatMessage)} active={editTimeLeft(d.createDate)}>
        {window.__ROLE__ !== 'DOCTOR' && editTimeLeft(d.createDate) && (
          <CommonHistoryEntryControls
            time={d.createDate}
            action={() => edit(name, d.documentId, getLatestFinishedCommitData(d))}
          />
        )}
        {(window.__ROLE__ === 'DOCTOR' || !editTimeLeft(d.createDate)) && (
          <CommonViewButton onView={e => view('fsmc', d.documentId)} />
        )}
      </HistoryEntryHeader>
      <HistoryEntryColumns>
        <HistoryEntryColumn header={renderHeader(formatMessage(msg('fsmc.labels.filled')))} smallScaling={6}>
          <p>{d.filled + ' / 20'}</p>
        </HistoryEntryColumn>
        <HistoryEntryColumn header={renderHeader(formatMessage(msg('fsmc.labels.scoreTotal')))} smallScaling={6}>
          <Row middle="xs">
            <Col xs={4} sm={4} md={2}>
              {d.scores.physical + d.scores.mental}
            </Col>
            {d.filled === 20 && (
              <Col>
                <IconButton style={{ ...styles.button }} iconStyle={styles.icon} onClick={setDialog(d, 'fsmc')}>
                  <Info color={styles.color} />
                </IconButton>
              </Col>
            )}
          </Row>
        </HistoryEntryColumn>
        <HistoryEntryColumn header={renderHeader(formatMessage(msg('fsmc.labels.scorePhysical')))} smallScaling={6}>
          <p>{d.scores.physical}</p>
        </HistoryEntryColumn>
        <HistoryEntryColumn header={renderHeader(formatMessage(msg('fsmc.labels.scoreMental')))} smallScaling={6}>
          <p>{d.scores.mental}</p>
        </HistoryEntryColumn>
      </HistoryEntryColumns>
    </HistoryEntry>
  );

export default historyMapper;
